module.exports = "/assets/dist/images/wagon_wide.jpg?0ffa573964ddf30d40b7e0b802f62ff7";